import { msg } from 'gt-react';

/**
 * Default Quick Find (⌘K) shortcuts, used until a user customizes their own in
 * Navigation settings. `keywords` is comma-separated and translated, so each
 * locale ships the abbreviations its users actually type. A template only
 * surfaces when the user can access `path`.
 */
export const QUICK_FIND_SHORTCUT_TEMPLATES: readonly {
  keywords: string;
  path: string;
}[] = [
  {
    keywords: msg('wf, automations', {
      context:
        'comma-separated Quick Find search shortcuts for the Workflows page; use abbreviations users type in this language',
    }),
    path: '/workflows',
  },
  {
    keywords: msg('bg agents, background agents', {
      context:
        'comma-separated Quick Find search shortcuts for the Background Agents page; use abbreviations users type in this language',
    }),
    path: '/agents',
  },
];
